import { ReactComponent as IconArrowDown } from '@whitelabel/media/icons/small/arrow-down.svg';
import { ReactComponent as IconArrowLeft } from '@whitelabel/media/icons/small/arrow-left.svg';
import { ReactComponent as IconArrowRight } from '@whitelabel/media/icons/small/arrow-right.svg';
import { ReactComponent as IconArrowUp } from '@whitelabel/media/icons/small/arrow-up.svg';
import { ReactComponent as IconBin } from '@whitelabel/media/icons/small/bin.svg';
import { ReactComponent as IconCalendar } from '@whitelabel/media/icons/small/calendar.svg';
import { ReactComponent as IconChevronDown } from '@whitelabel/media/icons/small/chevron-down.svg';
import { ReactComponent as IconChevronLeft } from '@whitelabel/media/icons/small/chevron-left.svg';
import { ReactComponent as IconChevronRight } from '@whitelabel/media/icons/small/chevron-right.svg';
import { ReactComponent as IconChevronUp } from '@whitelabel/media/icons/small/chevron-up.svg';
import { ReactComponent as IconCross } from '@whitelabel/media/icons/small/cross.svg';
import { ReactComponent as IconDanger } from '@whitelabel/media/icons/small/danger.svg';
import { ReactComponent as IconDocument } from '@whitelabel/media/icons/small/document.svg';
import { ReactComponent as IconDollar } from '@whitelabel/media/icons/small/dollar.svg';
import { ReactComponent as IconDownload } from '@whitelabel/media/icons/small/download.svg';
import { ReactComponent as IconEdit } from '@whitelabel/media/icons/small/edit.svg';
import { ReactComponent as IconEllipsis } from '@whitelabel/media/icons/small/ellipsis.svg';
import { ReactComponent as IconEmail } from '@whitelabel/media/icons/small/email.svg';
import { ReactComponent as IconHelp } from '@whitelabel/media/icons/small/help.svg';
import { ReactComponent as IconInfo } from '@whitelabel/media/icons/small/info.svg';
import { ReactComponent as IconPhone } from '@whitelabel/media/icons/small/phone.svg';
import { ReactComponent as IconPlus } from '@whitelabel/media/icons/small/plus.svg';
import { ReactComponent as IconPower } from '@whitelabel/media/icons/small/power.svg';
import { ReactComponent as IconProfile } from '@whitelabel/media/icons/small/profile.svg';
import { ReactComponent as IconSave } from '@whitelabel/media/icons/small/save.svg';
import { ReactComponent as IconSearch } from '@whitelabel/media/icons/small/search.svg';
import { ReactComponent as IconTick } from '@whitelabel/media/icons/small/tick.svg';
import { ReactComponent as IconWarning } from '@whitelabel/media/icons/small/warning.svg';
import { ReactComponent as IconCash } from '@whitelabel/media/icons/small/cash-note.svg';
import { ReactComponent as IconGuard } from '@whitelabel/media/icons/small/guard.svg';

export const STATUS_ACTIVE = 'ACTIVE';
export const STATUS_COMPLETED = 'COMPLETED';
export const STATUS_CONFIRMED = 'CONFIRMED';
export const STATUS_CANCELLED = 'CANCELLED';
export const STATUS_CLAIM_STARTED = 'CLAIM_STARTED';

export const POLICY_STATUS = {
  [STATUS_ACTIVE]: 'activePolicyStatus',
  [STATUS_COMPLETED]: 'completedPolicyStatus',
  [STATUS_CONFIRMED]: 'confirmedPolicyStatus',
  [STATUS_CANCELLED]: 'cancelledPolicyStatus',
};

export const CATEGORY = {
  APPLIANCES_INSURANCE: 'appliances-insurance',
  ELECTRONICS_INSURANCE: 'electronics-insurance',
  FURNITURE_INSURANCE: 'furniture-insurance',
  SUNGLASSES_INSURANCE: 'sunglasses-insurance',
  OUTDOORS_INSURANCE: 'outdoors-insurance',
  SPORTS_AND_FITNESS_INSURANCE: 'sports-and-fitness-insurance',
};

export const POLICY_TYPE = {
  APPLIANCES_COVER: 'appliances_cover',
  CONTENTS_COVER: 'contents_cover',
  CONTAINER_PROTECTION: 'container_protection',
  ELECTRONICS_COVER: 'electronics_cover',
  FURNITURE_COVER: 'furniture_cover',
  HOME_COVER: 'home_cover',
  INSTRUMENTS_COVER: 'instruments_cover',
  JEWELRY_COVER: 'jewelry_cover',
  LANDLORD_COVER: 'landlord_cover',
  OUTDOOR_COVER: 'outdoor_cover',
  PARCEL_COVER: 'parcel_cover',
  RENTAL_COVER: 'rental_cover',
  SPORTS_COVER: 'sports_cover',
  SUNGLASSES_COVER: 'sunglasses_cover',
  GADGET_COVER: 'gadget_cover',
  PARCEL_INSURANCE: 'parcel_insurance',
  LANDLORD_INSURANCE: 'landlord_insurance',
  PRODUCT_INSURANCE: 'product_insurance',
  PROPERTY_COVER: 'full_property_protection',
  RENTAL_PROPERTY_COVER: 'rental_property_protection',
  TRAVEL_FLIGHT_DELAY_COVER: 'travel_flight_delay_cover',
  TRAVEL_GADGETS_ITEMS_COVER: 'travel_gadgets_items_cover',
  TRAVEL_FLIGHT_CANCELLATION_COVER: 'travel_flight_cancellation_cover',
  TRAVEL_MEDICAL_COVER: 'travel_medical_cover',
  TRAVEL_PERSONAL_BAGGAGE: 'travel_personal_baggage',
  TRAVEL_PERSONAL_ELECTRONICS: 'travel_personal_electronics',
  EVENT_TICKET_PROTECTION: 'event_ticket_protection',
  COMPREHENSIVE_TRAVEL_INSURANCE: 'comprehensive_travel_insurance',
  TRACKER_WARRANTY: 'tracker_warranty',
  EARTHQUAKE_COVER: 'earthquake_cover',
};

export const POLICY_TYPES = Object.values(POLICY_TYPE);

export const TRAVEL_POLICY_TYPES = [
  POLICY_TYPE.TRAVEL_FLIGHT_DELAY_COVER,
  POLICY_TYPE.TRAVEL_GADGETS_ITEMS_COVER,
  POLICY_TYPE.TRAVEL_FLIGHT_CANCELLATION_COVER,
  POLICY_TYPE.TRAVEL_MEDICAL_COVER,
  POLICY_TYPE.TRAVEL_PERSONAL_BAGGAGE,
  POLICY_TYPE.TRAVEL_PERSONAL_ELECTRONICS,
  POLICY_TYPE.COMPREHENSIVE_TRAVEL_INSURANCE,
];

export const PRODUCT_POLICY_TYPES = [POLICY_TYPE.PRODUCT_INSURANCE];
export const EVENT_POLICY_TYPES = [POLICY_TYPE.EVENT_TICKET_PROTECTION];
export const PARCEL_POLICY_TYPES = [POLICY_TYPE.PARCEL_INSURANCE];
export const WARRANTY_POLICY_TYPES = [POLICY_TYPE.TRACKER_WARRANTY];
export const PARAMETRIC_POLICY_TYPES = [POLICY_TYPE.EARTHQUAKE_COVER];

export const XCOVER_PARTNER_ID = 'S6QVK';
export const AXS_PARTNER_ID = 'DQ3CJ';
export const EBAY_PARTNER_ID = 'ZNJ0A';
export const QUICKBOOKS_PARTNER_ID = '4ITH0';

export const INTERNAL_PARTNERS = [AXS_PARTNER_ID, XCOVER_PARTNER_ID, EBAY_PARTNER_ID];

export const SMALL_ICONS = {
  'arrow-down': IconArrowDown,
  'arrow-left': IconArrowLeft,
  'arrow-right': IconArrowRight,
  'arrow-up': IconArrowUp,
  bin: IconBin,
  calendar: IconCalendar,
  'chevron-down': IconChevronDown,
  'chevron-left': IconChevronLeft,
  'chevron-right': IconChevronRight,
  'chevron-up': IconChevronUp,
  cross: IconCross,
  danger: IconDanger,
  document: IconDocument,
  dollar: IconDollar,
  download: IconDownload,
  edit: IconEdit,
  ellipsis: IconEllipsis,
  email: IconEmail,
  help: IconHelp,
  info: IconInfo,
  phone: IconPhone,
  plus: IconPlus,
  power: IconPower,
  profile: IconProfile,
  save: IconSave,
  search: IconSearch,
  tick: IconTick,
  warning: IconWarning,
  cash: IconCash,
  guard: IconGuard,
};

export const QUOTE_QUESTIONS = 'quoteQuestions';
export const QUOTE_VALUES = 'quoteValues';
export const QUOTE_VALUES_FROM_URL = 'quoteValuesFromUrl';
export const USER_GEO = 'userGeo';
export const USER_COUNTRY = 'userCountry';
export const USER_CONTINENT = 'userContinent';

export const Z_INDEX = {
  HEADER: 'header',
  CONTENT: 'content',
  CONTENT_LAYER: 'contentLayer',
};

export const FORM_INPUT_TYPES = {
  ADDRESS: 'address',
};

export const CURRENCIES = {
  USD: 'USD',
  AUD: 'AUD',
};

export const SECURITY_TOKEN = 'securityToken';
export const XCOVER_TOKEN = 'xcoverToken';
export const XPAY_TOKEN = 'xpayToken';
export const XPAY_CHARGE_BUNDLE_ID = 'xpay-charge-bundle';
export const XPAY_PAYOUT_BUNDLE_ID = 'xpay-widget-bundle';
export const CONNECTED_TO_PAYPAL = 'connectedToPaypal';
export const CLOSE_PAYPAL_MODAL = 'closePaypalModal';
export const CAMPAIGN_ID = 'cid';
export const WHITE_LABEL_PREFIX = 'quickbooks-';
export const PERMITTED_COUNTRY_CODE = 'US';

export const INVALID_QUOTES = 'invalid quotes';
export const PROD = 'production';

export const CHARGE_TYPES = {
  AUTHORISATION: 'AUTHORISATION',
  ONE_OFF: 'ONE_OFF',
};

export const PAYMENT_METHODS = {
  PAYPAL: 'paypal',
  CREDIT_CARD: 'credit_card',
};

export const CURRENT_LOCALE = 'currentLocale';

export const IMPERSONATOR_TOKEN = 'impersonator_token';

export const EMAIL_PARAM = 'email';

export const TOOLTIP_TIMEOUT_DELAY = 3000;

export const BOOKING_ID = 'bookingID';

// Avoid to use this constant if possible,
// Use partner id constant instead for accuracy.
// eg: EBAY_PARTNER_ID
export const PARTNER_SLUG = {
  skyscanner: 'skyscanner',
};

export const hiddenLocaleCodes = ['en-us'];

// Regex
export const REGEX_INS_ALL_CASES = /([A-Z0-9]{5}-){2}INS/i;
export const REGEX_UUID = /[a-z0-9]{8}-([a-z0-9]{4}-){3}[a-z0-9]{12}/g;

/* zendesk custom field IDs */
export const REFERENCE_NUMBER_FILED_ID = 360000121216;
export const NPS_LANGUAGE_FILED_ID = 5175584420751;
export const PARTNER_FIELD_ID = 360000138875;
export const NPS_RATING_FIELD_ID = 4542737830031;
export const FEEDBACK_FIELD_ID = 4993050735887;
export const TOUCH_POINT_FIELD_ID = 5027977852559;
export const EMAIL_FIELD_ID = 360000222275;
